<template>
  <div class="columns">
    <div class="column is-half">
      <span class="is-pulled-right">
        <button
          type="button"
          class="button is-info"
          :class="{ 'is-loading': pdfBusy }"
          :disabled="!template_text || pdfBusy"
          @click.prevent.stop="onDownloadPdf"
        >
          <span class="icon">
            <i class="fa fa-file"></i>
          </span>
          <span>PDF Preview</span>
        </button>

        <button
          type="button"
          class="button is-success"
          :class="{ 'is-loading': saveBusy }"
          :disabled="!template_text || saveBusy"
          @click.prevent.stop="onSaveTemplate"
        >
          <span class="icon">
            <i class="fa fa-floppy-o"></i>
          </span>
          <span>SAVE</span>
        </button>
      </span>

      <h1 class="is-size-2">Template</h1>

      <b-field label="Name">
        <b-input v-model="template_name" size="is-small" />
      </b-field>
      <template-editor :template.sync="template_text"></template-editor>
    </div>

    <div class="column">
      <h1 class="is-size-2">Preview</h1>

      <template-preview
        :template="template_text"
        profile="order"
        ref="templatePreview"
      ></template-preview>
    </div>
  </div>
</template>

<script>
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
import { TemplateService } from "@/services/template.service.js";
import TemplateEditor from "@/components/Template/TemplateEditor.vue";
import TemplatePreview from "@/components/Template/TemplatePreview.vue";

export default {
  components: {
    TemplateEditor: TemplateEditor,
    TemplatePreview: TemplatePreview
  },
  data() {
    return {
      pdfBusy: false,
      saveBusy: false,
      template: {
        id: null,
        content: "" // we can watch this to update template text
      },
      template_name: "",
      template_text: ""
    };
  },
  watch: {
    "template.content": function(newVal) {
      this.template_text = newVal;
    },
    "template.name": function(newVal) {
      this.template_name = newVal;
    }
  },
  mounted() {
    const vm = this;
    this.$store.dispatch("routeLoading");
    this.getRouteData()
      .then(data => {
        const { template } = data;
        if (template) vm.template = template;
      })
      .catch(err => {
        vm.$buefy.toast.open({
          type: "is-danger",
          message: "Failed to fetch template."
        });
      })
      .finally(() => {
        vm.$store.dispatch("routeLoading", false);
      });
  },
  methods: {
    getRouteData() {
      const vm = this;
      return new Promise((resolve, reject) => {
        return Promise.all([vm.fetchTemplate()])
          .then(all => {
            const data = {
              template: all[0]
            };
            return resolve(data);
          })
          .catch(err => {
            return reject(err);
          });
      });
    },
    onDownloadPdf() {
      this.pdfBusy = true;
      this.$refs.templatePreview.onDownloadPdf().finally(() => {
        this.pdfBusy = false;
      });
    },
    onSaveTemplate() {
      const vm = this;
      const payload = {
        name: vm.template_name,
        type: "order", // temporary
        content: vm.template_text
      };
      const p = TemplateService.update(vm.template.id, payload);

      vm.saveBusy = true;

      return p
        .then(response => {
          const template = JsonDenormalizer.denormalize(response);
          vm.template = template;
        })
        .catch(err => {
          vm.$buefy.toast.open({
            type: "is-danger",
            message: "Failed to fetch template."
          });
        })
        .finally(() => {
          vm.saveBusy = false;
        });
    },
    fetchTemplate() {
      return new Promise((resolve, reject) => {
        TemplateService.show(this.$route.params.id)
          .then(response => {
            const template = JsonDenormalizer.denormalize(response);
            return resolve(template);
          })
          .catch(err => {
            return reject(err);
          });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Templates/edit.vue